import modalTemplate from './modal-qr-code-scanner.html';

export default class ButtonQrCodeScannerController {
	/* @ngInject */
	constructor($element, $uibModal) {
		this.$element = $element;
		this.$uibModal = $uibModal;
		this.ngModel = undefined;
		this.ngModelCtrl = undefined;
		this.onChange = undefined;
	}

	$onInit() {
		this.$element
			.addClass('btn btn-default')
			.on('click', () => this.qrReader());
	}

	$onDestroy() {
		this.$element.off('click');
	}

	qrReader() {
		const modalInstance = this.$uibModal.open({
			template:    modalTemplate,
			windowClass: 'modal-qr-code-scanner',
			controller:  /* @ngInject */ ($scope, $uibModalInstance) => {
				$scope.code = undefined;
				// Dès la premiere valeur scannée, ferme la modale + passe la valeur
				$scope.$watch(() => $scope.code, () => {
					this.ngModelCtrl.$setViewValue($scope.code);
					if ($scope.code !== undefined) {
						$uibModalInstance.close($scope.code);
					}
					this.$element.blur();
				});

				$scope.ok = () => {
					$uibModalInstance.close();
					this.$element.blur();
				};

				$scope.cancel = () => {
					$uibModalInstance.dismiss('cancel');
					this.$element.blur();
				};
			},
		});

		modalInstance.result
			.then(code => (typeof this.onChange === 'function' ? this.onChange({ value: code }) : null))
			.catch(error => {
				console.log('error', error);
			});
	}
}
